// extracted by mini-css-extract-plugin
module.exports = {"tax":"tax_tax__1M_p4","total":"tax_total__KO5h2","subtotal":"tax_subtotal__2qHvK"};